import { render } from "./SegmentViewer.vue?vue&type=template&id=4f45c59a&scoped=true"
import script from "./SegmentViewer.vue?vue&type=script&lang=js"
export * from "./SegmentViewer.vue?vue&type=script&lang=js"

import "./SegmentViewer.vue?vue&type=style&index=0&id=4f45c59a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f45c59a"]])

export default __exports__